import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-root">
        <div className="navigation-container">
          <a href="Homepage">
            <div className="navigation-logo-link">
              <div className="navigation-logo-wrapper">
                <span className="navigation-brand section-title">
                  <span>
                    Stratix
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="navigation-thq-navigation-brand-accent-elm1">
                    Group
                  </span>
                </span>
              </div>
            </div>
          </a>
          <div className="navigation-links-desktop">
            <ul className="navigation-menu-list">
              <li className="navigation-menu-item">
                <a href="Homepage">
                  <div className="navigation-link">
                    <span>Overview</span>
                  </div>
                </a>
              </li>
              <li className="navigation-menu-item">
                <a href="Divisions &amp; Services">
                  <div className="navigation-link">
                    <span>Divisions &amp; Services</span>
                  </div>
                </a>
              </li>
              <li className="navigation-menu-item">
                <a href="Contact &amp; Access">
                  <div className="navigation-link">
                    <span>Contact &amp; Access</span>
                  </div>
                </a>
              </li>
            </ul>
            <div className="navigation-cta-wrapper">
              <a href="Contact &amp; Access">
                <div className="btn btn-sm btn-primary">
                  <span>Portal Access</span>
                  <svg
                    fill="none"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
          <button
            id="nav-toggle-open"
            aria-label="Open Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              fill="none"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
              height="28"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="navigation-mobile-overlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <a href="Homepage">
            <div className="navigation-logo-link">
              <span className="navigation-brand section-title">
                <span>
                  Stratix
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="navigation-thq-navigation-brand-accent-elm2">
                  Group
                </span>
              </span>
            </div>
          </a>
          <button
            id="nav-toggle-close"
            aria-label="Close Menu"
            className="navigation-mobile-toggle"
          >
            <svg
              fill="none"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
              height="28"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-overlay-list">
            <li className="navigation-overlay-item">
              <a href="Homepage">
                <div className="navigation-overlay-link">
                  <span>Corporate Overview</span>
                </div>
              </a>
            </li>
            <li className="navigation-overlay-item">
              <a href="Divisions &amp; Services">
                <div className="navigation-overlay-link">
                  <span>Divisions &amp; Services</span>
                </div>
              </a>
            </li>
            <li className="navigation-overlay-item">
              <a href="Contact &amp; Access">
                <div className="navigation-overlay-link">
                  <span>Contact &amp; Access</span>
                </div>
              </a>
            </li>
          </ul>
          <div className="navigation-overlay-footer">
            <p className="navigation-stx-motto section-content">
              Skilled • Trusted • Execution
            </p>
            <a href="Contact &amp; Access">
              <div className="btn-lg btn navigation-overlay-cta btn-primary">
                <span>
                  {' '}
                  Client Portal
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
const navOverlay = document.getElementById('navigation-mobile-overlay');
const openBtn = document.getElementById('nav-toggle-open');
const closeBtn = document.getElementById('nav-toggle-close');
const overlayLinks = navOverlay.querySelectorAll('.navigation-overlay-link');

function toggleNav(state) {
  if (state) {
    navOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    openBtn.setAttribute('aria-expanded', 'true');
  } else {
    navOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
    openBtn.setAttribute('aria-expanded', 'false');
  }
}

openBtn.addEventListener('click', () => toggleNav(true));
closeBtn.addEventListener('click', () => toggleNav(false));

overlayLinks.forEach(link => {
  link.addEventListener('click', () => toggleNav(false));
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 767 && navOverlay.classList.contains('is-active')) {
    toggleNav(false);
  }
});
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
